export type ReportPrintGuardResult =
  | { ok: true }
  | { ok: false; message: string };

export const REPORT_PRINT_NOT_READY_MESSAGE =
  "O PDF ainda está ajustando a paginação. Aguarde um instante e tente imprimir novamente.";
export const REPORT_PRINT_OVERFLOW_MESSAGE =
  "O PDF não foi impresso porque o layout excedeu a página. Gere o relatório novamente.";
export const REPORT_PRINT_INCOMPLETE_MESSAGE =
  "O PDF não foi impresso porque a lista ficou incompleta. Gere o relatório novamente.";

const OVERFLOW_TOLERANCE_PX = 1;

export function checkReportPrintReady(
  root: ParentNode = document,
): ReportPrintGuardResult {
  const sources = Array.from(
    root.querySelectorAll<HTMLElement>(
      ".report-print-source-document:not(.report-print-measure-document)",
    ),
  );

  if (sources.length === 0) {
    return { ok: false, message: REPORT_PRINT_NOT_READY_MESSAGE };
  }

  for (const source of sources) {
    if (source.dataset.reportLayout !== "measured") {
      return { ok: false, message: REPORT_PRINT_NOT_READY_MESSAGE };
    }

    const expectedRows = Number(source.dataset.reportExpectedRowCount ?? "0");
    const renderedRows = Number(source.dataset.reportRenderedRowCount ?? "0");
    if (expectedRows !== renderedRows) {
      return { ok: false, message: REPORT_PRINT_INCOMPLETE_MESSAGE };
    }

    const pages = Array.from(
      source.querySelectorAll<HTMLElement>(".report-print-page"),
    ).filter((page) => !page.closest(".report-print-measure-document"));
    for (const page of pages) {
      if (page.scrollHeight - page.clientHeight > OVERFLOW_TOLERANCE_PX) {
        return { ok: false, message: REPORT_PRINT_OVERFLOW_MESSAGE };
      }
    }
  }

  return { ok: true };
}
